import { Grid } from '@material-ui/core';
import React from 'react';
import { useField } from 'formik';
import { FormInput, FieldUserSelect, FieldOrganizationSelect } from '../../../../components';
import { Organization } from '../../../../types/items';
import { useGuard } from '../../../../hooks';
import { is, roles } from '../../../../utility/guard';

type Props = {
  userFromId: number;
  organization: Organization;
};

const TransferCreditsForm = ({ organization, userFromId }: Props) => {
  const isAdmin = useGuard(is(roles.superAdmin));
  const fromOrganizationId = useField({ name: 'transfer_from_organization_id' })[0].value;
  const toOrganizationId = useField({ name: 'transfer_to_organization_id' })[0].value;

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={6}>
        <FormInput name="video_credits_qty" label="Credit Quantity" type="number" />
      </Grid>

      <Grid item xs={12} container spacing={2}>
        {isAdmin
          && (
            <Grid item xs={12} sm={6}>
              <FieldOrganizationSelect
                name={organization?.common_name}
                fieldName="transfer_from_organization_id"
                label="Organization To Transfer From"
              />
            </Grid>
          )}
        <Grid item xs={12} sm={6}>
          <FieldUserSelect
            optionalUserId={userFromId}
            organizationId={fromOrganizationId}
            name="transfer_from_user_id"
            label="User to Transfer From"
          />
        </Grid>

      </Grid>
      <Grid item xs={12} container spacing={2}>
        {isAdmin
        && (
          <Grid item xs={12} sm={6}>
            <FieldOrganizationSelect
              name={organization?.common_name}
              fieldName="transfer_to_organization_id"
              label="Organization To Transfer To"
            />
          </Grid>
        )}
        <Grid item xs={12} sm={6}>
          <FieldUserSelect
            organizationId={toOrganizationId}
            name="transfer_to_user_id"
            label="User to Transfer To"
          />
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <FormInput name="note" label="Note" type="textarea" />
      </Grid>
    </Grid>
  );
};

export default TransferCreditsForm;
